export const ROLES = {
  ADMIN: 'ADMIN',
  JUDGE: 'JUDGE',
  MANAGER: 'MANGER',
  BILLING: 'BILLING',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];